var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMybook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 17.5V19.1667H9.16669V17.5H2.50002C2.03979 17.5 1.66669 17.1269 1.66669 16.6667V3.33333C1.66669 2.8731 2.03979 2.5 2.50002 2.5H7.50002C8.4956 2.5 9.38927 2.93646 10 3.62848C10.6108 2.93646 11.5044 2.5 12.5 2.5H17.5C17.9603 2.5 18.3334 2.8731 18.3334 3.33333V16.6667C18.3334 17.1269 17.9603 17.5 17.5 17.5H10.8334ZM16.6667 15.8333V4.16667H12.5C11.5795 4.16667 10.8334 4.91286 10.8334 5.83333V15.8333H16.6667ZM9.16669 15.8333V5.83333C9.16669 4.91286 8.42052 4.16667 7.50002 4.16667H3.33335V15.8333H9.16669Z",
    fill: "#2F3444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMybook);
export default __webpack_public_path__ + "static/media/quick-mybook.d5f5d18089994d56ca1ee8e565b5be95.svg";
export { ForwardRef as ReactComponent };